// Backend returns status as ACTIVE / INACTIVE / MAINTENANCE.
export const branchStatusConfig = {
  ACTIVE: { labelKey: 'Active', color: '#1fd8a8', bgcolor: 'rgba(31,216,168,0.14)' },
  INACTIVE: { labelKey: 'Inactive', color: '#94a3b8', bgcolor: 'rgba(148,163,184,0.14)' },
  MAINTENANCE: { labelKey: 'Maintenance', color: '#f7b84b', bgcolor: 'rgba(247,184,75,0.14)' },
}

export const branchStatusOptions = [
  { value: 'ACTIVE', labelKey: 'Active' },
  { value: 'INACTIVE', labelKey: 'Inactive' },
]

// Default companyId until auth header drives it.
export const DEFAULT_COMPANY_ID = 1

export const branchColumns = [
  { id: 'select', labelKey: '', sortable: false },
  { id: 'name', labelKey: 'Branch Name', sortable: true },
  { id: 'branchCode', labelKey: 'Branch Code', sortable: true },
  { id: 'address', labelKey: 'Address', sortable: false },
  { id: 'facilities', labelKey: 'Facilities', sortable: false },
  { id: 'status', labelKey: 'Status', sortable: true },
  { id: 'action', labelKey: '', sortable: false },
]

// `value` is what hits the backend query (true/false). `all` is excluded by api.js.
export const mainBranchFilters = [
  { key: 'all', labelKey: 'All', value: undefined },
  { key: 'main', labelKey: 'Main', value: true },
  { key: 'sub', labelKey: 'Sub', value: false },
]
